import { useEffect } from 'react';
import { Divider } from '@cbhq/cds-web/layout';
import { ActionType, ComponentType } from '@cbhq/client-analytics';

import { useAnalytics } from '../../hooks/useAnalytics';
import { useProfileMenuV2 } from '../../providers/ProfileMenuV2Provider';
import { ManagedByBanner } from '../ManagedByBanner';

import { OtherAccounts } from './OtherAccounts';
import { SelectedProfile } from './Profile';

export function UserSwitcherProfiles() {
  const { logEvent } = useAnalytics();
  const { selectedProfile, otherProfiles } = useProfileMenuV2();

  useEffect(() => {
    logEvent('user_switcher_view', {
      action: ActionType.view,
      componentType: ComponentType.dropdown,
      otherProfilesCount: otherProfiles.length,
    });
  }, [logEvent, otherProfiles]);

  return (
    <>
      <ManagedByBanner />
      <SelectedProfile {...selectedProfile} />
      <Divider />
      <OtherAccounts otherProfiles={otherProfiles} />
    </>
  );
}
